import { Component, OnInit } from '@angular/core';
import { feedBackModel } from '../../models/feedback/feedback.model';
import { HttpTestService } from '../../services/http.service';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {
  public serviceOn : boolean = false;
  public feedBackModel: feedBackModel = new feedBackModel;
  public patterns: any = {
    mobileNo: "^[0-9]{10}$"
  };
  public successMsg: string ="";
  public errorMsg: string ="";
  requestOnProcess: boolean = false;
  constructor(public http: HttpTestService, public router: Router ) { }

  ngOnInit() {
  }

  saveFeedback(feedbackForm: NgForm){
    this.successMsg = "";
    this.errorMsg = "";
    this.requestOnProcess = true; 
    let feedBackObj: any = {};
    feedBackObj.consumerNo = this.feedBackModel.consumerNo;
    feedBackObj.name = this.feedBackModel.name;
    feedBackObj.mobileNo = this.feedBackModel.phoneNo;
    feedBackObj.feedbackText = this.feedBackModel.feedback;
    feedBackObj.emailId = this.feedBackModel.emailId;
    this.serviceOn = true;
    this.http.saveFeedback(feedBackObj).subscribe(
      success => {
        if (success['responseStatus'] == 1) {
          this.successMsg = success['responseMessage'];
          this.serviceOn = false;
          this.feedBackModel = new feedBackModel;
          feedbackForm.reset();
        } else {
          this.errorMsg = success['responseMessage'];
          this.serviceOn = false;
        }
        this.requestOnProcess = false;
      },
      error => {
        this.requestOnProcess = false;
      });
  }

  backToHomePage(){
   this.router.navigate(['/dashboard'],{ skipLocationChange: true });
  }

  resetConsumerNo() {
    this.feedBackModel.consumerNo = '';
  }

}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/feedback/feedback.component.ts